// HelloClaw configuration
export const BOOKING_URL = 'https://api.leadconnectorhq.com/widget/booking/S442pJP90RpLtN5FrwSF';